import { render, staticRenderFns } from "./BoDateField.vue?vue&type=template&id=7a36bb53&"
import script from "./BoDateField.vue?vue&type=script&lang=ts&"
export * from "./BoDateField.vue?vue&type=script&lang=ts&"
import style0 from "./BoDateField.vue?vue&type=style&index=0&id=7a36bb53&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports